import { Tabs, Table, Image, message, Spin } from 'antd';
import constants from '../../constants/constants';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useContext, useEffect, useState } from 'react';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import { CommonContext } from '../../Context';

const { TabPane } = Tabs;

const QualityFiltersSupplier = ({ filterValue }) => {
	//Variable Declaration
	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	const [suppliers, setSuppliers] = useState([]);
	const [loader,setLoader]=useState(false);

	// Function on load and when filterValue changes
	useEffect(() => {
		// Check the filterValue and trigger the API call if needed
		if (filterValue === "All" || filterValue === "Rules") {
			fetchData();
		}
	}, [filterValue]);

	//Functions
	//Function to get suppliers list
	const fetchData = async () => {
		setLoader(true);
		const supplierList = await APIUtils.apiCall("GET", WebLinks.QualityFilterSupplier + buyerId + '/qualityfiltersupplier');
		if (supplierList.isCatch) {
			setSuppliers([])
			setLoader(false);
		} else {
			if (supplierList.resultObj?.statusCode === "2000") {
				setSuppliers(supplierList.resultObj.data)
			}
			setLoader(false);
		}
	}

	const updateQualityFilter = async (value) => {
		setLoader(true);
		const newDatasource = suppliers.map((item) =>
			item.supplierId === value.supplierId ? { ...item, buyerQualityFilter: !item.buyerQualityFilter } : item
		);
		setSuppliers(newDatasource);
		setLoader(false);
		setLoader(true);
		const url = WebLinks.UpdateQualityFilterSupplier + buyerId + "&supplierId=" + value.supplierId;
		const response = await APIUtils.apiCall('POST', url);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
		    message.success(response.resultObj.message);
		}
		setLoader(false);
	}

	const deleteQualityFilter = async (value) => {
        const newDatasource = suppliers.map((item) =>
            item.supplierId === value.supplierId ? { ...item, buyerQualityFilter: !item.buyerQualityFilter } : item
        );
        setSuppliers(newDatasource);
        const url = WebLinks.DeleteQualityFilter + buyerId + "&supplierId=" + value.supplierId;
        const response = await APIUtils.apiCall('DELETE', url);
        if (!response.isCatch && response.resultObj.statusCode === "2000") {
			fetchData();
            message.success(response.resultObj.message);
        }
    }

	//Render
	return (
		<div>
			<Spin spinning={loader}>
			{filterValue !== "None" &&
				<Table
					pagination={false}
					dataSource={suppliers}
					scroll={{ x: '1000' }}
				>
					<Table.Column
						key="supplierId" title="Supplier" dataIndex="logoURL"
						render={(_, data) => (
							<div>
								{data.logoURL && data.logoURL !== "" ? <Image src={data.logoURL} preview={false} width={100} /> :
									data.supplierName}
							</div>
						)}
					/>
					<Table.Column key="buyerQualityFilter" title="Filter" dataIndex="buyerQualityFilter"
						render={(_, record) => (
							record.buyerQualityFilter ?
								(<CheckOutlined className='text-xl text-lime-500' onClick={() => deleteQualityFilter(record)} />) :
								(<CloseOutlined className='text-xl text-red-500' onClick={() => updateQualityFilter(record)} />)
						)}
					/>
				</Table>}
				</Spin>
		</div>
	);
};

export default QualityFiltersSupplier;